
import Vue from "vue"
// import props from "./props";

export default Vue.extend({
	data() {
		return {
			loaded: false,
			animationEnd: false
		}
	},
	props: {
		placeholder: {
			type: String,
			default: require(`@/assets/danmati_loading.gif`)
		},
		url: {
			type: String,
			default: 'https://img1.baidu.com/it/u=878394287,117902226&fm=253&fmt=auto&app=138&f=GIF?w=600&h=337'
		},
		duration: {
			type: Number,
			default: 1500
		}
	}, methods: {
		handleLoad() {
			this.loaded = true
			setTimeout(() => {
				this.$emit("loaded")
				this.animationEnd = true
			}, this.duration);
		}
	}

})
